export const AhaMoment = Object.freeze({
	AuditorsInCard: 'auditors_in_card',
});
